import { render } from "./Login-App.vue?vue&type=template&id=48e711f5&scoped=true"
import script from "./Login-App.vue?vue&type=script&lang=js"
export * from "./Login-App.vue?vue&type=script&lang=js"

import "./Login-App.vue?vue&type=style&index=0&id=48e711f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e711f5"]])

export default __exports__